import React, { FunctionComponent } from "react";

const ConversationChatTextIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/messages-chat-smileys/conversation/conversation-chat-text
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <defs></defs>
      <title>conversation-chat-text</title>
      <path
        d="M8.25,18l-3,2.25v-4.5h-3a1.5,1.5,0,0,1-1.5-1.5v-12A1.5,1.5,0,0,1,2.25.75h16.5a1.5,1.5,0,0,1,1.5,1.5v4.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <line
        x1="5.25"
        y1="5.25"
        x2="15.75"
        y2="5.25"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="5.25"
        y1="9.75"
        x2="8.25"
        y2="9.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <polygon
        points="23.25 18.75 20.25 18.75 20.25 23.25 15.75 18.75 11.25 18.75 11.25 9.75 23.25 9.75 23.25 18.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></polygon>
      <line
        x1="20.25"
        y1="12.75"
        x2="14.25"
        y2="12.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="20.25"
        y1="15.75"
        x2="14.25"
        y2="15.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </svg>
  );
};

export default ConversationChatTextIcon;
